import React from "react";

const Phone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.25 5.25h-4.5V.75a.75.75 0 0 0-1.5 0v4.5H.75a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 1 0 1.5 0v-4.5h4.5a.75.75 0 1 0 0-1.5"
    ></path>
  </svg>
);

export default Phone;
